/**
 * Plan-limit helpers shared by the UI's pre-submit checks.
 */

/**
 * Would admitting `selected` new units exceed the remaining allowance?
 *
 * - `limit === -1` (unlimited) or nullish (unknown) → never exceeds.
 * - otherwise remaining = max(0, limit - used); exceeds when selected > remaining.
 */
export function exceedsRemaining(
  selected: number,
  limit: number | undefined | null,
  used: number,
): boolean {
  if (limit === -1 || limit === undefined || limit === null) return false;
  const remaining = Math.max(0, limit - used);
  return selected > remaining;
}
